import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { History } from './history';

export function useBackButton(prevLocation: string = '/'): VoidFunction {
    const navigate = useNavigate();

    return useCallback(() => {
        if (History.getAllUrls().length) {
            navigate(-1);

            return;
        }

        navigate(prevLocation ? prevLocation : '/', { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigate]);
}
